import { z } from "zod";
import { createConsentValidation } from "@/components/site-builder/modules/CustomFormModule/utils/consent/createConsentValidation";
import { FormBuilderConsentFieldNames } from "@/constants/form-builder";
import { type FormBuilderConsentConfig } from "@/types/form-builder";
import type { TFunction } from "i18next";

export function getConsentValidationSchema(
  config: FormBuilderConsentConfig,
  t: TFunction,
) {
  const { combined, marketing, thirdParty } = config;

  const schemaFields: Record<string, z.ZodTypeAny> = {};

  if (combined.shown) {
    schemaFields[FormBuilderConsentFieldNames.CombineMarketing] =
      createConsentValidation({
        type: combined.inputType,
        required: combined.required,
        t,
      });
  }

  if (thirdParty.shown && thirdParty.text) {
    schemaFields[FormBuilderConsentFieldNames.ThirdParty] =
      createConsentValidation({
        type: thirdParty.inputType,
        required: thirdParty.required,
        t,
      });
  }

  if (marketing.shown && marketing.text) {
    schemaFields[FormBuilderConsentFieldNames.Marketing] =
      createConsentValidation({
        type: marketing.inputType,
        required: marketing.required,
        t,
      });
  }

  return z.object(schemaFields);
}
